import { render, staticRenderFns } from "./curriculum_student.vue?vue&type=template&id=c220283a&"
import script from "./curriculum_student.vue?vue&type=script&lang=js&"
export * from "./curriculum_student.vue?vue&type=script&lang=js&"
import style0 from "./curriculum_student.vue?vue&type=style&index=0&id=c220283a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports